import { useTranslation } from 'react-i18next';

const formatNumber = (num) => {
  if (num === null || num === undefined) return '';
  return Number(num).toLocaleString('en-US');
};

export default function ConfirmChanges({ codAmount, products, onConfirm, onCancel, isConfirming }) {
  const { t } = useTranslation();
  return (
    <div className="capitalize">
      <h1 className="font-semibold mb-2">{t('Confirm changes')}</h1>
      <div className="bg-calcareous-sinter rounded-lg p-3 mb-4 text-center">
        <p className="text-sm text-berwick-berry mb-1">{t('Target amount')} (COD)</p>
        <p className="text-xl font-bold text-bright-blue">{formatNumber(codAmount)} {t('EGP')}</p>
      </div>

      <p className="font-semibold mb-2">{t('Received products')}</p>
      <div className="bg-white rounded-lg border-2 border-coconut-white px-3 mb-4">
        <div className="divide-y divide-coconut-white">
          {products.map((p) => (
            <div key={p.id} className="flex justify-between items-center py-3 text-sm gap-2">
              <span className="truncate text-funnel-cloud">{p.name}</span>
              <span className="text-berwick-berry whitespace-nowrap flex-shrink-0">{t('Quantity')}: {p.receivedQty}</span>
            </div>
          ))}
        </div>
      </div>

      <p className="text-center font-semibold mb-1 text-Squid-Ink-Powder">{t('Check the shipment details carefully.')}</p>
      <p className="text-center text-sm text-berwick-berry mb-4">
        {t('Once confirmed, the order will be updated.')}
      </p>

      <button
        onClick={onConfirm}
        disabled={isConfirming}
        className="capitalize flex items-center gap-2 justify-center h-11 w-full bg-bright-blue text-white rounded-md font-medium shadow-[0_6px_14px_rgba(0,95,255,0.25)] transition hover:bg-frosted-blueberries focus:outline-none focus:ring-2 focus:ring-arc-light focus:ring-offset-2"
      >
        {isConfirming && (
          <span className="w-4 h-4 border-2 shrink-0 border-coconut-white border-t-transparent rounded-full animate-spin"></span>
        )}
        {t('Confirm changes')}
      </button>
      <button onClick={onCancel} className="mt-2 h-11 w-full border border-bright-blue text-bright-blue rounded-md font-medium transition hover:bg-cotton-ball focus:outline-none focus:ring-2 focus:ring-arc-light disabled:opacity-50 disabled:cursor-not-allowed">
        {t('Cancel')}
      </button>
    </div>
  );
}